// This definition is more of a place holder than anything else
import type { EditAssetWorkflowOptions } from '../../types';

export const editContractWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'editContractWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'contract',
  workflowIndex: 2,
  workflowName: 'Edit a contract',
  workflowDescription:
    'Contracts represent a group of rates for a given carrier, that you will use to cost shipments from a specific location/context',
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      archived: { type: 'boolean', const: false },
      active: { type: 'boolean', const: true },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Contract ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this contract',
        description: 'This is optional but will allow you to more easily reference this contract in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Contract Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What will you call this contract',
        description: 'Add a name for the contract to refer back to it.',
        help: '',
      },
      calculatedComponentProps: {
        defaultValue: {
          property: 'name',
          type: 'asset',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Contract Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a description (optional):',
        description: '',
        defaultValue: '',
        help: '',
        rows: 4,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'carrierAccountSelect',
      workflowStepNavigationName: 'Carrier Account Select',
      workflowComponent: {
        workflowComponentType: 'carrierAccountSelect',
        prompt: 'What carrier account does this contract use?',
        description: 'Select a carrier account whose credentials you will utilize in this contract',
        help: '',
      },
      calculatedComponentProps: {
        carrierId: {
          type: 'asset',
          property: 'carrierId',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'carrierAccount',
      },
    },
    {
      workflowStepKey: 'carrierSettingsSelect',
      workflowStepNavigationName: 'Carrier Setting Select',
      workflowComponent: {
        workflowComponentType: 'carrierSettingSelect',
        prompt: 'What carrier settings does this contract use?',
        description: 'Select the set of carrier settings you will utilize in this contract',
        help: '',
      },
      calculatedComponentProps: {
        carrierId: {
          type: 'asset',
          property: 'carrierId',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'carrierSettings',
      },
    },
    {
      workflowStepKey: 'carrierRateSetSelect',
      workflowStepNavigationName: 'Carrier Rateset Select',
      workflowComponent: {
        workflowComponentType: 'carrierRateSetSelect',
        prompt: 'Which carrier rates set is associated with this contract',
        description: 'Select the set of carrier rates you will utlize for costing in this context',
        help: 'Which carrier rates are associated with this contract',
      },
      calculatedComponentProps: {
        carrierId: {
          type: 'asset',
          property: 'carrierId',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'carrierRateSet',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this contract belong to a specific tenant?',
        description: '',
        help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
        optional: true,
      },
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
      calculatedComponentProps: {
        assetId: {
          type: 'asset',
          property: 'contractId',
        },
      },
      optional: true,
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Contract Summary',
        description: 'The contract will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
